import React, { useState } from "react";
import LogInPanel from "container/account/logIn/LogInPanel";
import ForgotPwRequestPanel from "container/account/logIn/ForgotPwRequestPanel";
import ForgotPwConfirmPanel from "container/account/logIn/ForgotPwConfirmPanel";
import PropTypes from "prop-types";

RootLogIn.propTypes = {
  toggleModeFn: PropTypes.func.isRequired,
  goNextUrl: PropTypes.func.isRequired,
  goToSocialPage: PropTypes.func.isRequired
};

function RootLogIn(props) {
  const { toggleModeFn, goNextUrl, goToSocialPage } = props;
  const [mode, setMode] = useState("logIn");
  const [email, setEmail] = useState(null);

  const handleLogInBtnClick = () => {
    setMode("logIn");
  };

  const handleForgotPwBtnClick = () => {
    setMode("pwRequest");
  };

  const handleRequestBtnClick = email => {
    setEmail(email);
    setMode("pwConfirm");
  };

  const handleConfirmBtnClick = () => {
    setMode("logIn");
  };

  return (
    <div>
      {mode === "logIn" && (
        <LogInPanel
          onModeToggleBtnClick={toggleModeFn}
          goNextUrl={goNextUrl}
          goToSocialPage={goToSocialPage}
          onForgotPwBtnClick={handleForgotPwBtnClick}
        />
      )}
      {mode === "pwRequest" && (
        <ForgotPwRequestPanel
          onLogInBtnClick={handleLogInBtnClick}
          onRequestBtnClick={handleRequestBtnClick}
          goToSocialPage={goToSocialPage}
        />
      )}
      {mode === "pwConfirm" && (
        <ForgotPwConfirmPanel
          email={email}
          onConfirmBtnClick={handleConfirmBtnClick}
        />
      )}
    </div>
  );
}

export default RootLogIn;
